import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
  showArrow?: boolean;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  href,
  className = '',
  variant = 'primary',
  showArrow = true,
  ...props
}) => {
  const baseStyles = 'relative inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-bold transition-all duration-300 rounded-lg overflow-hidden group';
  const variants = {
    primary: 'bg-gold-gradient text-black hover:shadow-[0_0_30px_-5px_rgba(212,175,55,0.5)]',
    outline: 'bg-transparent border-2 border-brand-gold text-brand-gold hover:bg-brand-gold/10'
  };
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-43">
        {children}
        {showArrow && <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-44" />}
      </span>
      {variant === 'primary' && <div className="absolute inset-0 z-0 transition-opacity duration-300 opacity-0 bg-gold-gradient-hover group-hover:opacity-100" data-id="element-45" />}
    </>;
  const MotionButton = motion.button;
  const MotionAnchor = motion.a;
  if (href) {
    return <MotionAnchor href={href} className={`${baseStyles} ${variants[variant]} ${className}`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-46">
        {content}
      </MotionAnchor>;
  }
  return <MotionButton className={`${baseStyles} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-47">
      {content}
    </MotionButton>;
};